<!--
     <MetricEditModal
       title_prefix="Medida"
       :fix_type='false'
       :readonly='false'
     />

     Public methods:
       launch(metric_config)

     Events:
       save(new_metric_config)
       cancel(old_metric_config)
-->

<template>
  <ModalDialog
    :title="$t('indicators.new_measure_modal')"
    :showModalDialog="show"
    :fields_to_collect="fields"
    :submit_button_text="$t('dialog.save')"
    :unit="current_unit"
    @close-dialog="close"
    @submit="save"
    validate
  >
  </ModalDialog>
</template>

<style lang="scss">
 @import "@/sass/variables.scss";

 .mem-cont {
   width: 100%;
   display: flex;
   flex-direction: column;
   padding: 8px;
 }

 header.mem {
   display: flex;
   flex-direction: row;
   width: 100%;
   align-items: center;
   justify-content: space-between;
 }

 footer.mem {
   display: flex;
   flex-direction: row;
   justify-content: flex-end;
   align-items: center;
   width: 100%;
 }

 h1.imi {
   font-size: 1.6em;
   font-weight: bold;
 }

 .imi-list {
   
 }

 imi.button {
   
 }
</style>

<script>
 import MetricEditCategory from '@/components/indicator/MetricEditCategory';
 import MetricEditNumber from '@/components/indicator/MetricEditNumber';
 import MetricEditIndicator from '@/components/indicator/MetricEditIndicator';
 import { TYPES_NAMES } from '@/utils/indicator.js';

 function deep_copy(dict) {
   return JSON.parse(JSON.stringify(dict));
 }

 export default {
   name: 'MetricEditModal',

   components: {
     MetricEditCategory,
     MetricEditNumber,
     MetricEditIndicator,
     ModalDialog: ()=> import('@/components/explorer/ModalDialog.vue'),
   },

   props: [
     'title_prefix',
     'readonly',
     'allowed_types',
     'fix_type',
     'current_unit'
   ],

   data: () => ({
     show: false,
     original: {},
     name: '',
     description: '',
     weight: 1,
     variable_type: null,
     metric_value: {},
     id: null,
     fields: null,
   }),

   computed: {
     title() {
       return `${this.title_prefix}: ${this.name || this.$t('indicators.new_measure')}`;
     },

     types() {
       return (Object
         .entries(TYPES_NAMES)
         .filter(([k, z]) => (!this.allowed_types || this.allowed_types.indexOf(k) >= 0))
         .map(([k, v]) => ({key: k, name: this.$t('indicators.measures_types_names.'+k)}))
       );
     },
     
     
   },

   methods: {
     fields_to_collect(name, description, weight, variable_type, metric_value) {
      this.fields = [
        [
          {
            component: "TextInput",
            id: "name",
            label: this.$t('labels.name'),
            placeholder: "",
            readonly: false,
            required: true,
            cols: 8,
            value: name,
          }, {
            component: "NumericInput",
            id: "weight",
            label: this.$t('labels.weight'),
            placeholder: "",
            readonly: false,
            required: true,
            decimals: 2,
            cols: 4,
            value: weight,
          }
        ], [{
          component: "Tag",
          id: "warning1",
          label: "NOTA: Para hacer medias ponderadas de 0 a 100, utilize pesos decimales hasta sumar 1. Ejemplo: (0.3*medida1), (0.2*medida2), (0.5*medida3)", // TODO: Translation
          placeholder: "",
          readonly: false,
          required: true,
          decimals: 2,
          value: weight,
        }], [{
          component: "TextareaInput",
          id: "description",
          label: this.$t('labels.description'),
          placeholder: "",
          readonly: false,
          required: false,
          value: description,
        }], [{
          component: "MetricEdit",
          id: "metric_config",
          placeholder: "",
          readonly: false,
          required: true,
          type: variable_type,
          value: metric_value,
          allowed_types: this.allowed_types,
          cols: 6,
        }]
      ]
     },

     launch(metric_config) {

       this.original    = metric_config;
       this.name        = metric_config.name || '';
       this.description = metric_config.description || '';
       this.weight      = metric_config.weight || 1;
       this.id          = metric_config.id;
       this.variable_type = metric_config.type;
       this.metric_value = metric_config.metric_config;

       this.fields_to_collect(this.name, this.description, this.weight, this.variable_type, this.metric_value)
       this.$nextTick(()=> {
        this.show = true;
       }); 
       
     },

     serialize(form) {
       console.log('*******', form);
       const metric_config = JSON.parse(form.metric_config || '');
       // const metric_config = form;
       const res = {
         'id': this.id,
         'name': form.name || this.name,
         'description': form.description || this.description,
         'weight': form.weight || this.weight,
         'type': metric_config.type || this.variable_type,
         'metric_config': metric_config.value || {},
       };
       console.log('→→→→→→→→→', res);

       return res;
     },

     is_valid() {
       // TODO
       return true;
     },

     save(something) {
      const form = Object.fromEntries(something.entries());
       if (!this.is_valid())
         return;
       this.show = false;
       this.$emit('save', this.serialize(form));
     },

     close() {
       this.show = false;
       this.$emit('cancel', this.original);
     },
   },
 }
</script>
<style lang="scss">
 @import '@/sass/modalform.scss';
</style>
